var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuditTrailIcon = function SvgAuditTrailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m22.59 4.642-.045-.315-.255-.187a17.42 17.42 0 0 0-20.603.052l-.247.188-.045.315A17.385 17.385 0 0 0 11.7 23.093l.3.157.3-.128A17.42 17.42 0 0 0 22.8 7.155a17 17 0 0 0-.21-2.513M12 21.585a15.92 15.92 0 0 1-9.278-14.46q.006-.941.12-1.875a15.92 15.92 0 0 1 18.308-.083q.116.976.12 1.958A15.92 15.92 0 0 1 12 21.585M8.115 10.973l3.135 3.134 5.558-5.55L15.75 7.5l-4.5 4.5-2.07-2.085z",
    clipRule: "evenodd"
  })));
};
export default SvgAuditTrailIcon;